// Formatter for our studentKeys for parchment
const studentKeyToStudentIdForTranscript = (studentKey?: number): string => {
  if (!studentKey) return ''
  const zerosLeft = 7 - studentKey.toString().length
  return `C${'0'.repeat(zerosLeft)}${studentKey}`
}

export default studentKeyToStudentIdForTranscript
